import React from 'react';
import { CardContentProps } from './types';
import './Card.css';

const CardContent: React.FC<CardContentProps> = ({
  children,
  className = '',
  sx = {},
}) => {
  const contentClasses = [
    'raith-card__content',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={contentClasses} style={sx}>
      {children}
    </div>
  );
};

export default CardContent;